import React from 'react'
import RoomContainer from './RoomContainer'

const WebinarRoom = (props) => (
  <RoomContainer {...props} />
)

export default WebinarRoom



// WEBPACK FOOTER //
// src/routes/Room/WebinarRoom.js